export default __webpack_public_path__ + "static/media/about_us_venture1.8b88c231.png";